import styled, { css } from 'styled-components';

export interface IText {
  $size?: 'xsmall' | 'xsmallStatic' | 'small' | 'smallStatic' | 'standard' | 'large';
  $tone?: 'main' | 'alt' | 'success' | 'error' | 'secondary';
  $align?: 'left' | 'center' | 'right';
  $weight?: 'light' | 'regular' | 'medium' | 'bold';
  $decoration?: 'line-through';
}

export const Text = styled.div.withConfig({ componentId: 'sc-vz25os-0' })<IText>`
    ${({ $size }) =>
      $size === 'xsmall'
        ? css`
                  font-size: ${(props) => props.theme.font.size.xsmall};
              `
        : $size === 'xsmallStatic'
          ? css`
                  font-size: var(--font-size-xsmall-static);
              `
          : $size === 'small'
            ? css`
                  font-size: ${(props) => props.theme.font.size.small};
              `
            : $size === 'smallStatic'
              ? css`
                  font-size: var(--font-size-small-static);
              `
              : $size === 'standard'
                ? css`
                  font-size: ${(props) => props.theme.font.size.regular};
              `
                : $size === 'large'
                  ? css`
                  font-size: ${(props) => props.theme.font.size.large};
              `
                  : undefined}

    ${({ $tone }) =>
      $tone === 'main'
        ? css`
                  color: var(--c-text-main);
              `
        : $tone === 'alt'
          ? css`
                  color: var(--c-text-muted);
              `
          : $tone === 'success'
            ? css`
                  color: var(--c-semantic-success-700);
              `
            : $tone === 'error'
              ? css`
                  color: var(--c-semantic-error-700);
              `
              : $tone === 'secondary'
                ? css`
                  color: var(--c-secondary-fg);
              `
                : undefined}

  ${({ $align }) =>
    $align === 'left'
      ? css`
                  text-align: left;
              `
      : $align === 'center'
        ? css`
                  text-align: center;
              `
        : $align === 'right'
          ? css`
                  text-align: right;
              `
          : undefined}

  ${({ $weight }) =>
    $weight === 'light'
      ? css`
                  font-weight: var(--font-weight-light);
              `
      : $weight === 'regular'
        ? css`
                  font-weight: var(--font-weight-regular);
              `
        : $weight === 'medium'
          ? css`
                  font-weight: var(--font-weight-medium);
              `
          : $weight === 'bold'
            ? css`
                  font-weight: var(--font-weight-bold);
              `
            : undefined}

  ${({ $decoration }) =>
    $decoration === 'line-through'
      ? css`
                  text-decoration: line-through;
              `
      : undefined}
`;
